import React from 'react';
import Table from 'components/table';

import history from '../../history';

export const UsersList = ({ user }) => (
  <Table black hover>
    <thead>
      <tr>
        <th>ID</th>
        <th>ПІБ</th>
        <th>Установа</th>
        <th>E-mail</th>
        <th>Номер телефону</th>
      </tr>
    </thead>
    <tbody>
      {user.map((item, i) => (
        <tr key={i} onClick={(event) => {
          history.push(`/admin/personal/detail/${item.get('id')}`)
        }}>
          <td><span>ID: </span>{item.get('id')}</td>
          {item.get('user_data') ? (
            <td><span>ПІБ: </span>{item.getIn(['user_data', 'last_name'])} {item.getIn(['user_data', 'first_name'])} {item.getIn(['user_data', 'middle_name'])}</td>
          ):(
            null
          )}
          <td><span>Установа: </span>{item.getIn(['institution_data','full_title'])}</td>
          <td><span>E-mail:</span>{item.getIn(['user_data', 'email']) ? item.getIn(['user_data', 'email']) : "-"}</td>
          <td><span>Номер телефону:</span>{item.get('phone') ? item.get('phone') : "-"}</td>

        </tr>
      ))}
    </tbody>
  </Table>
)



// WEBPACK FOOTER //
// ./src/admin/users/users-list.js